<template>
  <div class="ma-4">
   <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
    <v-data-table
      :headers="headers"
      :items="reviews"
      sort-by="review"
      sort-asc
      class="elevation-1"
      :loading="isLoading"
      loading-text="Loading Reviews"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Performance Reviews</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="search"
            label="search"
          ></v-text-field>
          <v-spacer></v-spacer>
          <!-- <v-dialog v-model="dialog" max-width="75%">
            <template v-slot:activator="{ on }">
              <v-btn color="#2b3990" dark class="mb-2" v-on="on" @click="showAdd()"
                >
                <v-icon left>add</v-icon>
                Add Performance Review</v-btn
              >
            </template>
            <v-card>
              <v-card-title style="background-color: #2b3990">
                <span class="headline white--text">{{ titleForm  }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <v-text-field
                        v-model="newCode"
                        label="Service Code"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <v-text-field
                        v-model="newTitle"
                        label="Service Code Title"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <v-autocomplete
                        v-model="newUnit"
                        label="Unit of Service"
                        outlined
                        :items="units"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#259647" class="white--text" @click="addCode()" v-if="newServCode">Save</v-btn
                >
                <v-btn color="blue darken-1" text @click="updateCode()" v-if="editCode">Update</v-btn
                >
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog> -->
        </v-toolbar>

      </template>

     <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="viewReview(item)">
          mdi-eye
        </v-icon>
        <!-- <v-icon small class="mr-2" @click="editCode(item)">
          mdi-pencil
        </v-icon> -->
        <v-icon small @click="deleteCode(item)">
          mdi-delete
        </v-icon>
        <!-- <v-icon small @click="addDeal(item)">
          add
        </v-icon> -->
      </template>
      <template v-slot:no-data>
        <v-btn color="#2b3990" class="white--text" @click="getReviews()">Reset</v-btn>
      </template>
    </v-data-table>
    <Foot/>
  </div>
</template>

<script>
import axios from 'axios'
import Foot from '../components/Footer'

const url = require("../client_config/config").url;

export default {
  components: {
      Foot,
  },
  data: function() {
    return {
      headers: [
        {
          text: 'Review',
          align: 'start',
          sortable: false,
          value: 'Review',
        },
        { text: "Employee", value: "EmployeeName" },
        { text: "Review Date", value: "EmployeeDate" },
        { text: "Reviewed By", value: "StaffName" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      dialog: false,
      editReview: false,
      newServCode: false,
      msg: false,
      search: "",
      text:"",
      reviews: [],
      reviewID: "",
      newCode: "",
      newTitle: "",
      newUnit: "",
      editedIndex: -1,
      editedItem: {
        code: "",
        title: "",
        units: "",
      },
      defaultItem: {
        code: "",
        title: "",
        units: "",
      },
      isLoading: true,
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.getReviews();
  },

  methods: {
    initialize() {
      this.reviews = [];
    },
    viewReview(item) {
      this.titleForm= "Viewing " + item.Review;
      this.dialog = true;
      this.editReview = true;
      // this.newServCode = false;
      this.newCode= item.Code;
      this.newTitle= item.Title;
      this.newUnit= item.Unit;
      this.codeID= item._id;
    },
    showAdd() {
      this.titleForm= "New Service Code";
      this.newServCode = true;
      this.editCode  = false;
    },

    deleteCode(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this service code?") &&
      this.codeDelete(id);

    },

    codeDelete(id) {
      axios.delete(`${url}/codes/${id}`)
      .then((response) => {
        this.getCodes();
        if (response.status == 400) {
          response.json().then(function(data) {
            return data.msg;
          });
        }
        this.msg=true;
        this.text="The code has been deleted successfully.";
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    updateCode() {
      var req_body = {
        Code: this.newCode,
        Title: this.newTitle,
        Unit: this.newUnit,
      };
      axios.put(`${url}/codes/${this.codeID}`, req_body).then((response) => {
        this.getCodes();
        if (response.status == 400) {
          response.json().then(function(data) {
            alert(data.msg);
          });
        }
        this.newCode= "";
        this.newTitle = "";
        this.newUnit = "";
        this.msg =true;
        this.text ="The service code has been updated successfully.";
      });
      this.close();
    },
    getReviews: function() {
      this.isLoading = true;
      axios.get(`${url}/performanceReview`).then(res => {
        this.reviews = res.data.reviews;
      }).finally(() => this.isLoading = false);
    },

    addCode: function() {
      var req_body = {
        Code: this.newCode,
        Title: this.newTitle,
        Unit: this.newUnit,
      };

      axios.post(`${url}/codes`, req_body ).then(res => {
        this.getCodes();
        if (res.status == 400) {
          res.json().then(function(data) {
            this.text=data.msg;
          });
        }
        this.newCode = "";
        this.newTitle = "";
        this.newUnit = "";
        this.msg =true;
        this.text ="The new sevice code has been added successfully.";
      });
      this.close();
    },
  },

};
</script>
